'use strict';

/**
 * FilterDropdown
 *
 * @author Mathias Hayoz <mathias.hayoz@namics.com>
 */
T.Module.FilterDropdown = T.createModule({

	_selectors: {
		input: '[data-js-m-filter-dropdown__input]'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// References
		this.$input = this.$ctx.find(this._selectors.input);

		// Component Event Binding
		this.$input.on('change', this.$onSelectChange.bind(this));

		// Configurable Change Event
		this.changeEventName = this.$input.data('change-event');

		this.initSelect2();

		resolve();
	},
	$onSelectChange: function $onSelectChange(event) {
		if (this.changeEventName) {
			var value = $(event.target).val();
			var type = $(event.target).attr('id');
			this._events.emit(this.changeEventName, type, value);
		}
	},
	initSelect2: function initSelect2() {
		this.$input.select2({
			allowClear: true
		}).on('select2:unselecting', function () {
			// This prevents opening the dropdown after clear is pressed.
			// Only needed for filter dropdown, as for all the other
			// use cases, the page was refreshed after clear.
			// https://github.com/select2/select2/issues/3320
			var opts = $(this).data('select2').options;
			opts.set('disabled', true);
			setTimeout(function () {
				return opts.set('disabled', false);
			}, 1);
		});
	}
});